import React from 'react';
import {
  StickyHeader,
  DesktopNav,
  DesktopPhonePill,
  BrandLogo,
} from '../../design-system/components';
import { Property } from '../../services/api';
import { BackIcon, HeartIcon, ShareIcon } from './icons';
import { SeoData } from './buildSeoData';

// 1. StickyHeader — md+ DesktopNav, lg+ DesktopPhonePill
export const DetailStickyHeader: React.FC<{
  property: Property;
  seoData: SeoData;
  onBack: () => void;
  isFavorited: boolean;
  favoriteLoading: boolean;
  onFavoriteToggle: () => void;
}> = ({ property, seoData, onBack, isFavorited, favoriteLoading, onFavoriteToggle }) => (
  <StickyHeader
    left={
      <div className="flex items-center gap-6">
        <button
          type="button"
          onClick={onBack}
          className="app-header-back flex h-11 w-11 items-center justify-center text-ink md:hidden"
          aria-label="뒤로"
        >
          <BackIcon />
        </button>
        <BrandLogo className="hidden md:flex" />
        <DesktopNav />
      </div>
    }
    // v2h(2026-09-22) 목업 모바일 04 앱바: 뒤로(아이콘) · 단지명(가운데) · 공유 · 관심
    centerMode="always"
    center={
      <b className="block truncate text-left text-[15px] font-semibold tracking-[-0.025em] text-ink md:hidden">{property.title}</b>
    }
    right={
      <>
        <DesktopPhonePill className="mr-1" />
        <button
          type="button"
          onClick={onFavoriteToggle}
          disabled={favoriteLoading}
          aria-label={isFavorited ? '찜 해제' : '찜하기'}
          className={`flex h-11 w-11 items-center justify-center rounded-ca-md transition-colors ${
            isFavorited ? 'text-bad' : 'text-muted hover:text-ink'
          }`}
        >
          <HeartIcon filled={isFavorited} />
        </button>
        <button
          type="button"
          onClick={() => {
            if (navigator.share) {
              navigator.share({
                title: property.title,
                text: seoData.description,
                url: seoData.url,
              }).catch(() => {});
            } else {
              navigator.clipboard?.writeText(seoData.url);
            }
          }}
          aria-label="공유"
          className="flex h-11 w-11 items-center justify-center rounded-ca-md text-muted hover:text-ink"
        >
          <ShareIcon />
        </button>
      </>
    }
  />
);
